import React from 'react'
import { mount } from 'enzyme'
import GenieTab from '../features/dashboard/GenieTab'

describe('<GenieTab />', () => {
  let wrapper, props
  const noop = () => { }
  beforeEach(() => {
    props = {
      onClick: noop,
      text: 'test'
    }
    wrapper = mount(<GenieTab {...props} />)
  })
  it('should call its onClick prop when it is clicked', () => {
    const onClickMock = jest.fn()
    wrapper.setProps({ onClick: onClickMock })
    wrapper.find('div').at(0).simulate('click')
    expect(onClickMock).toHaveBeenCalledTimes(1)
  })
  it('should render its provided text', () => {
    expect(wrapper.find('div').at(1).text()).toEqual(props.text)
  })
})
